import { instance } from '../lib/api'
import Constants from '../utils/CommonConstants'
import { API_FAIL } from './dashboard'

export const ACCOUNT_PAYMENT_BUCKET_DETAILS_IN_PROGRESS =
  'ACCOUNT_PAYMENT_BUCKET_DETAILS_IN_PROGRESS'
export const ACCOUNT_PAYMENT_BUCKET_DETAILS_SUCCESS =
  'ACCOUNT_PAYMENT_BUCKET_DETAILS_SUCCESS'
export const ACCOUNT_PAYMENT_BUCKET_DETAILS_ERROR =
  'ACCOUNT_PAYMENT_BUCKET_DETAILS_ERROR'
export const YES_BANK_AMOUNT_TRANSFER_FAIL = 'YES_BANK_AMOUNT_TRANSFER_FAIL'
export const YES_BANK_AMOUNT_TRANSFER_SUCCESS =
  'YES_BANK_AMOUNT_TRANSFER_SUCCESS'

export const getSellerWalletInfo = accountId => dispatch => {
  const url = `sapna/v1/seller-wallet-payments/${accountId}`
  dispatch({
    type: ACCOUNT_PAYMENT_BUCKET_DETAILS_IN_PROGRESS
  })
  return instance({
    url,
    method: 'get'
  })
    .then(response => {
      const { data: { data: details = {} } = {} } = response
      dispatch({
        type: ACCOUNT_PAYMENT_BUCKET_DETAILS_SUCCESS
      })
      return details
    })
    .catch(err => {
      dispatch({
        type: ACCOUNT_PAYMENT_BUCKET_DETAILS_ERROR,
        msg: Constants.getErrorMessage(err)
      })
    })
}

export const getYesBankWalletInfo = accountId => dispatch => {
  const url = `sapna/v1/bucketInfo/${accountId}?type=CLEARED,BOUNCED`
  dispatch({
    type: ACCOUNT_PAYMENT_BUCKET_DETAILS_IN_PROGRESS
  })
  return instance({
    url,
    method: 'get'
  })
    .then(response => {
      const { data: { data: details = {} } = {} } = response
      dispatch({
        type: ACCOUNT_PAYMENT_BUCKET_DETAILS_SUCCESS
      })
      return details
    })
    .catch(err => {
      dispatch({
        type: ACCOUNT_PAYMENT_BUCKET_DETAILS_ERROR,
        msg: Constants.getErrorMessage(err)
      })
    })
}
export const handleYesBankWalletTransfer = data => dispatch => {
  const { transferReason, destinationAccountNumber, responseId } = data
  const url = 'sapna/v1/wallet-transfer'
  return instance({
    url,
    method: 'put',
    data: {
      yesBankResponseId: responseId,
      destinationAccountId: destinationAccountNumber,
      reason: transferReason
    }
  })
    .then(response => {
      const { data: { data: msg = '' } = {} } = response
      dispatch({
        type: YES_BANK_AMOUNT_TRANSFER_SUCCESS,
        msg
      })
    })
    .catch(err => {
      dispatch({
        type: API_FAIL,
        errMsg: Constants.getErrorMessage(err)
      })
    })
}

export const handleSellerWalletTransfer = data => dispatch => {
  const { transferReason, destinationAccountNumber, responseId } = data
  const url = 'sapna/v1/seller-wallet-transfer'
  return instance({
    url,
    method: 'put',
    data: {
      walletPaymentId: responseId,
      destinationAccountId: destinationAccountNumber,
      reason: transferReason
    }
  })
    .then(response => {
      const { data: { data: msg = '' } = {} } = response || {}
      dispatch({
        type: YES_BANK_AMOUNT_TRANSFER_SUCCESS,
        msg
      })
    })
    .catch(err => {
      dispatch({
        type: API_FAIL,
        errMsg: Constants.getErrorMessage(err)
      })
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/yesBankWalletTransfer.js
 **/